import { combineReducers } from "@reduxjs/toolkit";
import { reducer as calendarReducer } from "src/slices/calendar";
import { reducer as chatReducer } from "src/slices/chat";
import { reducer as kanbanReducer } from "src/slices/kanban";
import { reducer as mailReducer } from "src/slices/mail";
import { reducer as linesheetReducer } from "src/slices/linesheet";
import { reducer as priceManagementReducer } from "src/slices/price-management";
import { reducer as priceSetupReducer } from "src/slices/price-setup";
import { reducer as bookingProcessReducer } from "src/slices/booking-process";
import { reducer as productAttributesReducer } from "src/slices/product-attributes";
import { reducer as purchaseOrdersReducer } from "src/slices/purchase-orders";
import { reducer as eTafReducer } from "src/slices/e-taf";
import { reducer as bookingSystemReducer } from "src/slices/booking-system";
import { reducer as portalSettingsReducer } from "src/slices/portal-settings";
import { reducer as assetsReducer } from "src/slices/assets";
import { reducer as suppliersReducer } from "src/slices/suppliers";
import { reducer as inboundProcessReducer } from "src/slices/inbound-process";
import { reducer as spacesDOSettingsReducer } from "src/slices/spaces-do-settings";

export const rootReducer = combineReducers({
  calendar: calendarReducer,
  chat: chatReducer,
  kanban: kanbanReducer,
  mail: mailReducer,
  linesheet: linesheetReducer,
  priceManagement: priceManagementReducer,
  priceSetup: priceSetupReducer,
  bookingProcess: bookingProcessReducer,
  productAttributes: productAttributesReducer,
  purchaseOrders: purchaseOrdersReducer,
  eTaf: eTafReducer,
  bookingSystem: bookingSystemReducer,
  portalSettings: portalSettingsReducer,
  assets: assetsReducer,
  suppliers: suppliersReducer,
  inboundProcess: inboundProcessReducer,
  spacesDOSettings: spacesDOSettingsReducer,
});
